function initWholesaleGuard() {
  if (!window.Eurus || !window.Eurus.loadedScript) return;
  if (window.Eurus.loadedScript.has('wholesale-guard.js')) return;
  window.Eurus.loadedScript.add('wholesale-guard.js');
 
  // Bail immediately for B2B customers — wholesale products are allowed
  const IS_B2B = window.isB2BCustomer || false;
  if (IS_B2B) return;
 
  let inFlight = false;
 
  async function enforceWholesaleRule() {
    if (inFlight) return;
    if (window.updatingCart) {
      await Alpine.store('xCartHelper').waitForCartUpdate();
    }
    inFlight = true;
    try {
      const cart = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' }
      }).then(r => r.json());
 
      if (!cart || cart.item_count === 0) return;
 
      // product_type is available directly on cart line items — no extra fetch needed
      const wholesaleItems = cart.items.filter(item => item.product_type === 'Wholesale');
      if (wholesaleItems.length === 0) return;
 
      const updates = {};
      wholesaleItems.forEach(item => { updates[item.key] = 0; });
 
      const sectionIds = Alpine.store('xCartHelper')
                            .getSectionsToRender()
                            .map(s => s.id);
 
      const res = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: sectionIds,
          sections_url: window.location.pathname
        })
      }).then(r => r.json());
 
      if (res && res.sections) {
        Alpine.store('xCartHelper').reRenderSections(res.sections);
      } else {
        Alpine.store('xMiniCart').reLoad();
      }
 
      const bubble = document.querySelector('#cart-icon-bubble span');
      Alpine.store('xCartHelper').currentItemCount = bubble ? parseInt(bubble.innerHTML, 10) : 0;
 
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    } catch (err) {
      console.error('wholesale-guard:', err);
    } finally {
      inFlight = false;
    }
  }
 
  document.addEventListener('eurus:cart:items-changed', enforceWholesaleRule);
  enforceWholesaleRule();
}
 
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWholesaleGuard);
} else {
  initWholesaleGuard();
}
 